"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTraitConfig = void 0;
var GetCommonConfigByType_1 = require("./GetCommonConfigByType");
var getTraitConfig = function (_a) {
    var widgetType = _a.widgetType, traitName = _a.traitName;
    return (0, GetCommonConfigByType_1.getCommonConfigByType)(widgetType).traits[traitName];
};
exports.getTraitConfig = getTraitConfig;
